(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
    typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
    (factory((global['react-l10n'] = {}),global.React));
}(this, (function (exports,React) { 'use strict';

    var Context = React.createContext({
        localize: (id, data, children) => id
    });

    class TextToken {
        constructor(text) {
            this.text = text;
        }
        apply(ctx, results) {
            results.push(this.text);
        }
    }

    class ValueToken {
        constructor(expression = '') {
            this.expression = expression.trim();
        }
        apply(ctx, results) {
            results.push(ctx.getValue(this.expression));
        }
    }

    class SwitchToken {
        static create(value, caseConditions, caseValues) {
            let cases = {};
            for (let idx = 0; idx < caseConditions.length; idx++) {
                cases[caseConditions[idx].trim()] = caseValues[idx];
            }
            return new SwitchToken(value, cases);
        }
        constructor(expression = '', cases = {}) {
            this.expression = expression.trim();
            this.cases = cases;
        }
        apply(ctx, results) {
            let tokens = this.getTokens(ctx);
            if (tokens) {
                tokens.forEach(token => token.apply(ctx, results));
            }
        }
        getTokens(ctx) {
            return this.cases[ctx.getValue(this.expression)];
        }
    }

    class IfConditionToken extends SwitchToken {
        constructor(expression = '', cases = []) {
            super(expression, {
                true: cases[0],
                false: cases[1]
            });
        }
        getTokens(ctx) {
            return this.cases[String(!!ctx.getValue(this.expression))];
        }
    }

    const QUESTION = '?';
    const EQUAL = '=';
    const SLASH = '\\';
    const SPACE = ' ';
    const OPENING_BRACKET = '{';
    const CLOSING_BRACKET = '}';
    class StringTokenizer {
        static tokenize(chars = []) {
            const result = [];
            const tokenizer = new StringTokenizer(chars);
            while (tokenizer.hasMoreTokens()) {
                result.push(tokenizer.nextToken());
            }
            return result;
        }
        constructor(chars = []) {
            this.chars = chars;
            this.start = 0;
            this.position = 0;
            this.length = this.chars.length;
        }
        hasMoreTokens() {
            return this.hasNextChar();
        }
        nextToken() {
            let token = null;
            if (this.current() === OPENING_BRACKET) {
                this.start = ++this.position; // shifting to start of expression (wo opening bracket)
                token = this.parseExpression();
            }
            if (token === null) {
                this.readUntilExpressionStart();
                if (!this.next()) {
                    // случай когда в конце {
                    this.position++;
                }
                token = new TextToken(this.substr());
            }
            this.start = this.position;
            return token;
        }
        hasNextChar() {
            return this.position < this.length;
        }
        current() {
            return this.chars[this.position];
        }
        next() {
            return this.chars[this.position + 1];
        }
        substr(start = -1) {
            return this.slice(start).join('');
        }
        slice(start = -1) {
            return this.chars.slice(start > -1 ? start : this.start, this.position);
        }
        parseExpression() {
            let value = '';
            let caseConditions = [];
            let caseValues = [];
            let isSwitch = false;
            let isIfCondition = false;
            let isExpressionFinished = false;
            while (this.position < this.length && !isExpressionFinished) {
                let current = this.current();
                if (current === SPACE) {
                    this.position++;
                    continue;
                }
                switch (current) {
                    case QUESTION: { // value passed - switch started
                        value = this.substr();
                        this.start = this.position + 1;
                        isSwitch = true;
                        isIfCondition = true;
                        break;
                    }
                    case EQUAL: { // switch condition passed - next will be switch value
                        caseConditions.push(this.substr());
                        isIfCondition = false;
                        break;
                    }
                    case OPENING_BRACKET: { // start of switch condition value
                        let start = ++this.position;
                        this.readUntilExpressionEnd();
                        this.start = this.position + 1;
                        caseValues.push(StringTokenizer.tokenize(this.slice(start)));
                        break;
                    }
                    case CLOSING_BRACKET: { // end of expression
                        if (!isSwitch) {
                            value = this.substr();
                        }
                        isExpressionFinished = true;
                        break;
                    }
                }
                this.position++;
            }
            if (isExpressionFinished) {
                if (isIfCondition && caseValues) {
                    return new IfConditionToken(value, caseValues);
                }
                if (isSwitch && caseConditions && caseValues) {
                    return SwitchToken.create(value, caseConditions, caseValues);
                }
                return new ValueToken(value);
            }
            return new TextToken(value);
        }
        readUntilExpressionStart() {
            this.readUntil(current => current === OPENING_BRACKET);
        }
        readUntilExpressionEnd() {
            let openBrackets = 0;
            this.readUntil(current => {
                if (current === OPENING_BRACKET) {
                    openBrackets++;
                }
                else if (current === CLOSING_BRACKET) {
                    if (openBrackets) {
                        openBrackets--;
                    }
                    else {
                        return true;
                    }
                }
                return false;
            });
        }
        readUntil(predicate) {
            let escaped = false;
            while (this.hasNextChar()) {
                let current = this.current();
                if (current === SLASH) {
                    const next = this.next();
                    if (next === SLASH || next === OPENING_BRACKET) {
                        this.chars.splice(this.position, 1);
                        this.length--;
                        escaped = true;
                        continue;
                    }
                }
                if (!escaped && predicate(current)) {
                    break;
                }
                escaped = false;
                this.position++;
            }
        }
    }

    function tokenize (string = '') {
        return StringTokenizer.tokenize(string.split(''));
    }

    class Resource {
        constructor(resource) {
            this._tokens = tokenize(resource);
        }
        tokens(ctx) {
            const results = [];
            this._tokens.forEach(token => token.apply(ctx, results));
            return results;
        }
    }

    class ResourcesBundle {
        constructor(resources) {
            this.resources = {};
            this.parse(resources);
        }
        get(id) {
            const resource = this.resources[id];
            if (resource) {
                if (typeof resource === 'string') {
                    this.resources[id] = new Resource(resource);
                }
                return this.resources[id];
            }
            return null;
        }
        parse(resources, prefix) {
            if (resources) {
                for (let key in resources) {
                    if (resources.hasOwnProperty(key)) {
                        const id = prefix ? `${prefix}.${key}` : key;
                        const value = resources[key];
                        if (Array.isArray(value)) {
                            value.forEach((resource, index) => {
                                this.resources[`${id}[${index}]`] = resource;
                            });
                        }
                        else if (typeof value === 'object') {
                            this.parse(value, id);
                        }
                        else {
                            this.resources[id] = value;
                        }
                    }
                }
            }
        }
    }

    function getValue(part, source) {
        if (part) {
            const matches = part.match(/(.*?)\[(.*?)\]/);
            if (matches) {
                const array = source[matches[1]];
                return array && array[matches[2]];
            }
            if (source instanceof Map) {
                return source.get(part);
            }
            return source[part];
        }
        return undefined;
    }
    function accessObject (key, source) {
        let result = undefined;
        let keyParts = key.split('.');
        if (keyParts.length === 1) {
            result = getValue(keyParts[0], source);
        }
        else {
            for (let idx = 0; idx < keyParts.length; idx++) {
                result = getValue(keyParts[idx], result || source);
                if (!result) {
                    break;
                }
            }
        }
        return result;
    }

    class ResourceContext {
        constructor(data = {}, children = {}) {
            this.data = data;
            this.children = children;
        }
        getValue(key) {
            let value = accessObject(key, this.data);
            if (!value) {
                value = this.children[key];
            }
            return value;
        }
    }

    class LocalizationProvider extends React.Component {
        constructor(props) {
            super(props);
            this.bundle = new ResourcesBundle(props.resources);
        }
        componentWillReceiveProps(nextProps) {
            if (this.props.resources !== nextProps.resources) {
                this.bundle = new ResourcesBundle(nextProps.resources);
            }
        }
        render() {
            const localize = (id, data, children) => {
                let resource = this.bundle.get(id);
                if (resource) {
                    return resource.tokens(new ResourceContext(data, children));
                }
                if (this.props.onMissingResource) {
                    return this.props.onMissingResource(id);
                }
                return id;
            };
            return (React.createElement(Context.Provider, { value: { localize } }, this.props.children));
        }
    }

    var LocalizationConsumer = Context.Consumer;

    function LocalizedMessage(props) {
        const children = {};
        React.Children.map(props.children, child => {
            if (child.key) {
                children[child.key] = child;
            }
            return children;
        });
        return (React.createElement(LocalizationConsumer, null, ({ localize }) => localize(props.id, props, children)));
    }

    exports.LocalizationProvider = LocalizationProvider;
    exports.LocalizationConsumer = LocalizationConsumer;
    exports.default = LocalizedMessage;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map
